/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
const UpgradePlan: FC = () => {
  return (
    <div className='modal fade' id='kt_modal_upgrade_plan' aria-hidden='true'>
     
    </div>
  )
}

export {UpgradePlan}
